const topicData = [
  { name: '明星八卦', count: '128万帖', icon: 'ri-star-line', color: 'bg-primary-100 text-primary-600' },
  { name: '影视综艺', count: '96万帖', icon: 'ri-movie-2-line', color: 'bg-accent-100 text-accent-600' },
  { name: '社会热点', count: '85万帖', icon: 'ri-fire-line', color: 'bg-secondary-100 text-secondary-600' },
  { name: '情感生活', count: '73万帖', icon: 'ri-heart-line', color: 'bg-primary-100 text-primary-600' },
  { name: '搞笑趣闻', count: '67万帖', icon: 'ri-emotion-laugh-line', color: 'bg-accent-100 text-accent-600' },
  { name: '科技数码', count: '52万帖', icon: 'ri-smartphone-line', color: 'bg-secondary-100 text-secondary-600' },
  { name: '体育赛事', count: '48万帖', icon: 'ri-basketball-line', color: 'bg-primary-100 text-primary-600' },
  { name: '美食探店', count: '41万帖', icon: 'ri-restaurant-line', color: 'bg-accent-100 text-accent-600' },
  { name: '旅游出行', count: '36万帖', icon: 'ri-plane-line', color: 'bg-secondary-100 text-secondary-600' },
  { name: '游戏电竞', count: '33万帖', icon: 'ri-gamepad-line', color: 'bg-primary-100 text-primary-600' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-accent-100">
            <i className="ri-hashtag text-accent-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">话题广场</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">发现你感兴趣的话题圈，加入讨论</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicData.map((topic) => (
            <a
              key={topic.name}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="flex flex-col items-center gap-2 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <span className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${topic.color} group-hover:scale-110 transition-transform`}>
                <i className={`${topic.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}